// NOTE: This file is copied from iding-admin
// 克隆节点之前做的操作
const beforeHandler = (dom) => {
  const canvasList = dom.querySelectorAll('canvas');
  // canvas转换png图片
  for (let i = 0; i < canvasList.length; i += 1) {
    if (!canvasList[i].style.display) {
      const parent = canvasList[i].parentNode;
      const canvasUrl = canvasList[i].toDataURL('image/png');
      const img = new Image();
      img.className = 'canvasImg';
      img.style.display = 'none';
      img.src = canvasUrl;
      parent.appendChild(img);
    }
  }
  return dom;
};
// 根据type去处理form表单
const getFormData = (ele) => {
  const copy = ele.cloneNode(true);
  const copiedInputs = copy.querySelectorAll('input,select,textarea');
  const canvasImgList = copy.querySelectorAll('.canvasImg,canvas');
  let selectCount = -1;
  // 处理所有canvas
  for (let i = 0; i < canvasImgList.length; i += 1) {
    const parent = canvasImgList[i].parentNode;
    const item = canvasImgList[i];
    // 删除克隆后的canvas节点
    if (`${item.tagName}`.toLowerCase() === 'canvas') {
      parent.removeChild(item);
    } else {
      item.style.display = 'block';
    }
  }
  // 处理所有输入框
  for (let i = 0; i < copiedInputs.length; i += 1) {
    const item = copiedInputs[i];
    let typeInput = item.getAttribute('type');
    const copiedInput = copiedInputs[i];
    // 获取select标签
    if (!typeInput) {
      typeInput = '';
      if (item.tagName === 'SELECT') {
        typeInput = 'select';
      } else if (item.tagName === 'TEXTAREA') {
        typeInput = 'textarea';
      }
    }
    // 处理input框
    if (item.tagName === 'INPUT') {
      // 除了单选框 多选框比较特别
      if (typeInput === 'radio' || typeInput === 'checkbox') {
        copiedInput.setAttribute('checked', item.checked);
        //
      } else {
        copiedInput.value = item.value;
        copiedInput.setAttribute('value', item.value);
      }
      // 处理select
    } else if (typeInput === 'select') {
      selectCount += 1;
      for (let b = 0; b < ele.querySelectorAll('select').length; b += 1) {
        const select = ele.querySelectorAll('select')[b]; // 获取原始层每一个select
        // eslint-disable-next-line no-unused-expressions
        !select.getAttribute('newbs') && select.setAttribute('newbs', b); // 添加标识
        if (select.getAttribute('newbs') === selectCount) {
          const opSelectedIndex = ele.querySelectorAll('select')[selectCount].selectedIndex;
          item.options[opSelectedIndex].setAttribute('selected', true);
        }
      }
      // 处理textarea
    } else {
      copiedInput.innerHTML = item.value;
      copiedInput.setAttribute('html', item.value);
    }
  }

  return copy;
};

export default class {
  constructor(option) {
    this.standards = {
      strict: 'strict',
      loose: 'loose',
      html5: 'html5',
    };
    this.selectArray = [];
    this.counter = 0;
    this.settings = {
      standard: this.standards.html5,
      extraHead: '',
      extraCss: '',
      popTitle: '',
      endCallback: null,
      ids: '',
    };
    Object.assign(this.settings, option);

    this.init();
  }

  init() {
    this.counter += 1;
    this.settings.id = `printArea_${this.counter}`;
    const PrintAreaWindow = this.getPrintWindow();
    this.write(PrintAreaWindow.doc);
    this.print(PrintAreaWindow);
  }

  // eslint-disable-next-line consistent-return
  print(PAWindow) {
    const paWindow = PAWindow.win;
    const loaded = () => {
      paWindow.focus();
      paWindow.print();
      try {
        const box = document.getElementById(this.settings.id);
        const canvasList = this.elsdom.querySelectorAll('.canvasImg');
        setTimeout(() => {
          for (let i = 0; i < canvasList.length; i += 1) {
            const parent = canvasList[i].parentNode;
            parent.removeChild(canvasList[i]);
          }
          box.parentNode.removeChild(box);
        }, 500);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    };
    if (window.ActiveXObject) {
      paWindow.onload = loaded();
      return false;
    }
    // safari 瀏覽器 需要延遲後才獲取得到window
    // 參考 https://stackoverflow.com/questions/23626998/safari-print-issue-with-javascript-window-print
    setTimeout(() => {
      if (paWindow) {
        paWindow.onload = loaded();
      }
    }, 500);
  }

  write(PADocument) {
    PADocument.open();
    PADocument.write(
      `${this.docType()}<html>${this.getHead()}${this.getBody()}</html>`,
    );
    PADocument.close();
  }

  docType() {
    if (this.settings.standard === this.standards.html5) {
      return '<!DOCTYPE html>';
    }
    const transitional = this.settings.standard === this.standards.loose ? ' Transitional' : '';
    const dtd = this.settings.standard === this.standards.loose ? 'loose' : 'strict';

    return `<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01${transitional}//EN" "http://www.w3.org/TR/html4/${dtd}.dtd">`;
  }

  getHead() {
    let extraHead = '';
    let links = '';
    let style = '';
    if (this.settings.extraHead) {
      this.settings.extraHead.replace(/([^,]+)/g, (m) => {
        extraHead += m;
      });
    }
    // 复制所有link标签
    [].forEach.call(document.querySelectorAll('link'), (item) => {
      if (item.href.indexOf('.css') >= 0) {
        links += `<link type="text/css" rel="stylesheet" href="${item.href}" >`;
      }
    });
    // 循环获取style标签的样式
    const domStyle = document.styleSheets;
    if (domStyle && domStyle.length > 0) {
      for (let i = 0; i < domStyle.length; i += 1) {
        try {
          if (domStyle[i].cssRules || domStyle[i].rules) {
            const rules = domStyle[i].cssRules || domStyle[i].rules;
            for (let b = 0; b < rules.length; b += 1) {
              style += rules[b].cssText;
            }
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(domStyle[i].href + e);
        }
      }
    }

    if (this.settings.extraCss) {
      this.settings.extraCss.replace(/([^,\s]+)/g, (m) => {
        links += `<link type="text/css" rel="stylesheet" href="${m}">`;
      });
    }

    return `<head><title>${this.settings.popTitle}</title>${extraHead}${links}<style type="text/css">${style}</style></head>`;
  }

  getBody() {
    let { ids } = this.settings;
    // eslint-disable-next-line prefer-regex-literals
    ids = ids.replace(new RegExp('#', 'g'), '');
    this.elsdom = beforeHandler(document.getElementById(ids));
    const ele = getFormData(this.elsdom);
    const htm = ele.outerHTML;
    return `<body>${htm}</body>`;
  }

  getPrintWindow() {
    const f = this.Iframe();
    return {
      f,
      win: f.contentWindow || f,
      doc: f.doc,
    };
  }

  Iframe() {
    const frameId = this.settings.id;
    let iframe;
    const that = this;
    try {
      iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      iframe.style.border = '0px';
      iframe.style.position = 'absolute';
      iframe.style.width = '0px';
      iframe.style.height = '0px';
      iframe.style.right = '0px';
      iframe.style.top = '0px';
      iframe.setAttribute('id', frameId);
      iframe.setAttribute('src', new Date().getTime());
      iframe.doc = null;
      // eslint-disable-next-line no-nested-ternary
      iframe.doc = iframe.document;
      if (iframe.contentDocument) {
        iframe.doc = iframe.contentDocument;
      } else if (iframe.contentWindow) {
        iframe.doc = iframe.contentWindow.document;
      }
      iframe.onload = () => {
        const win = iframe.contentWindow || iframe;
        that.print(win);
      };
    } catch (e) {
      throw new Error(`${e}. iframes may not be supported in this browser.`);
    }

    if (iframe.doc == null) {
      throw new Error('Cannot find document.');
    }

    return iframe;
  }
}
